import { createContext, useCallback, useMemo, useState } from "react";
import { GlobalDialogContextType, GlobalDialogProviderProps } from "./types";
import { DialogView } from "./DialogView";

const defaultState: GlobalDialogContextType = {
	showDialog: () => {},
	hideDialog: () => {},
};

export const GlobalDialogContext = createContext<GlobalDialogContextType>(defaultState);

const GlobalDialogProvider = ({ children }: GlobalDialogProviderProps) => {
	
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState<string>();
    const [dialogContent, setDialogContent] = useState<JSX.Element>();

	const showDialog = useCallback(
		(title: string, content: JSX.Element) => {
			setIsDialogOpen(true);
            setDialogTitle(title);
            setDialogContent(content);
		},
		[setIsDialogOpen, setDialogTitle, setDialogContent]
	);

	const hideDialog = useCallback(
		() => {
			setIsDialogOpen(false);
            setDialogTitle(undefined);
            setDialogContent(undefined);
		},
		[setIsDialogOpen, setDialogTitle, setDialogContent]
	);

	const contextValue = useMemo(
		() => ({ showDialog, hideDialog }),
		[showDialog, hideDialog]
	);

	return (
		<GlobalDialogContext.Provider value={contextValue}>
            {dialogTitle && dialogContent && <DialogView
				content={dialogContent}
				title={dialogTitle}
				open={isDialogOpen}
				setOpen={setIsDialogOpen}
			/>}
			{children}
		</GlobalDialogContext.Provider>
	);
};

export default GlobalDialogProvider;
